import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  CLEAR_SUPPLIER,
  CLEAR_SUPPLIER_FOOD_TYPE,
  CLEAR_SUPPLIERS,
  FLAG_GETTING_SUPPLIERS,
  FLAG_SUPPLIER_ACTIVITY,
  FLAG_SUPPLIER_FOOD_TYPE_ACTIVITY,
  GET_SUPPLIER,
  GET_SUPPLIER_FOOD_TYPE,
  GET_SUPPLIERS,
} from '../types';
import { SUPPLIER_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { SUPPLIER_PATH } from '../../config/paths';

const flagGettingSuppliers = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_SUPPLIERS,
    payload: flag,
  });

const getSuppliers = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingSuppliers(true));
    const query = tableFilters;
    const url = `${SUPPLIER_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const suppliers = await response.json();
    dispatch({
      type: GET_SUPPLIERS,
      payload: suppliers,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingSuppliers(false));
  }
};

const clearSuppliers = () => (dispatch) =>
  dispatch({
    type: CLEAR_SUPPLIERS,
  });

const flagSupplierActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_SUPPLIER_ACTIVITY,
    payload: flag,
  });

const getSupplier =
  async ({ supplierId }) =>
  async (dispatch) => {
    try {
      dispatch(flagSupplierActivity(true));
      const url = `${SUPPLIER_ENDPOINT}/${supplierId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const supplier = await response.json();
      dispatch({
        type: GET_SUPPLIER,
        payload: supplier,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagSupplierActivity(false));
    }
  };

const clearSupplier = () => (dispatch) =>
  dispatch({
    type: CLEAR_SUPPLIER,
  });

const postSupplier =
  async ({
    businessId,
    locationId,
    userId,
    billingType,
    type,
    creditTime,
    bankAccountNumber,
    phoneNumber,
    active,
    supplierFoodTypeList,
  }) =>
  async (dispatch) => {
    try {
      dispatch(flagSupplierActivity(true));
      const payload = {
        businessId,
        locationId,
        userId,
        billingType,
        type,
        creditTime,
        bankAccountNumber,
        phoneNumber,
        active,
        supplierFoodTypeList,
      };
      const url = SUPPLIER_ENDPOINT;
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const supplier = await response.json();

      dispatch(push(`${SUPPLIER_PATH}/${supplier.id}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagSupplierActivity(false));
    }
  };

const putSupplier =
  async (
    supplierId,
    {
      businessId,
      locationId,
      userId,
      billingType,
      type,
      creditTime,
      bankAccountNumber,
      phoneNumber,
      active,
      supplierFoodTypeList,
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagSupplierActivity(true));
      const payload = {
        businessId,
        userId,
        locationId,
        billingType,
        type,
        creditTime,
        bankAccountNumber,
        phoneNumber,
        active,
        supplierFoodTypeList,
        id: supplierId,
      };
      const url = `${SUPPLIER_ENDPOINT}/${supplierId}`;
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const supplier = await response.json();

      dispatch(push(`${SUPPLIER_PATH}/${supplier.id}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagSupplierActivity(false));
    }
  };

const flagSupplierFoodTypeActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_SUPPLIER_FOOD_TYPE_ACTIVITY,
    payload: flag,
  });

const getSupplierFoodType =
  ({ supplierId }) =>
  async (dispatch) => {
    try {
      dispatch(flagSupplierFoodTypeActivity(true));

      const url = `${SUPPLIER_ENDPOINT}/food-type/${supplierId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

      await isErrorResponse(response, null, dispatch);

      const supplierFoodTypeList = await response.json();

      dispatch({
        type: GET_SUPPLIER_FOOD_TYPE,
        payload: supplierFoodTypeList,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagSupplierFoodTypeActivity(false));
    }
  };

const getSupplierFoodTypeBySupplierAndItinerary =
  ({ supplierId, itineraryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagSupplierFoodTypeActivity(true));

      const query = QueryString.stringify({
        supplierId,
        itineraryId,
      });

      const url = `${SUPPLIER_ENDPOINT}/food-type?${query}`;

      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

      await isErrorResponse(response, null, dispatch);

      const supplierFoodTypeList = await response.json();

      dispatch({
        type: GET_SUPPLIER_FOOD_TYPE,
        payload: supplierFoodTypeList,
      });

      return supplierFoodTypeList;
    } catch ({ message }) {
      toastr.error('Error', message);
      return [];
    } finally {
      dispatch(flagSupplierFoodTypeActivity(false));
    }
  };

const clearSupplierFoodType = () => (dispatch) =>
  dispatch({
    type: CLEAR_SUPPLIER_FOOD_TYPE,
  });

export {
  flagGettingSuppliers,
  getSuppliers,
  clearSuppliers,
  getSupplier,
  clearSupplier,
  flagSupplierActivity,
  postSupplier,
  putSupplier,
  flagSupplierFoodTypeActivity,
  getSupplierFoodType,
  getSupplierFoodTypeBySupplierAndItinerary,
  clearSupplierFoodType,
};
